<div class="icon-container">
  <img src="assets/icon/input-pin.svg" alt="PIN Icon" class="pin-icon" />
</div>
<div class="p-card-title">Change PIN</div>
<div class="p-card-subtitle">
  {{ subTitle() }}
</div>

<div>
  <code-input
    #codeInput
    class="pin-input"
    [isCodeHidden]="true"
    [codeLength]="6"
    [isCharsCode]="false"
    (codeChanged)="onCodeChanged($event)"
    [ngClass]="{
      'invalid shake': error$(),
    }"
  >
  </code-input>

  <p class="warning-message" *ngIf="error$()">
    <span>{{ error$() }}</span>
  </p>
</div>
<button (click)="forgotPin()" class="forgot-pin">Forgot PIN?</button>
<div class="button-group">
  <div class="action-buttons">
    <lib-button (click)="cancel()" label="Cancel" type="Secondary" width="120px"></lib-button>
    <lib-button
      (click)="next()"
      width="120px"
      label="Next"
      type="Primary"
      [disabled]="!pinValue"
    ></lib-button>
  </div>
</div>

<app-block-loading [show]="isLoading()"></app-block-loading>
